import { Component, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, share } from 'rxjs/operators';

import { trigger, state, style, transition, animate } from '@angular/animations';
import { compileComponentClassMetadata } from '@angular/compiler';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { ThemeMenuComponent } from '../shared/components/themes/theme-menu/theme-menu.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Globals } from '../shared/models/globals';
import { ThemeService } from '../shared/services/themes/theme.service';
import { Option } from '../shared/models/themes/option.model';
import { MatSidenav } from '@angular/material/sidenav';
import { TeamService } from '../shared/services/team.service';
import { TeamOverviewModel } from '../shared/models/team.model';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AppColorsService } from '../shared/services/app-colors.service';


@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
    imports: [CommonModule, MaterialModule, RouterModule, TranslateModule],
    animations: [
        trigger('opacityAnim', [
            state('in', style({
                opacity: 1
            })),
            state('out', style({
                opacity: 0,
                transform: 'translateY(100%)'
            })),
            transition('* => *', animate('100s ease-in-out'))
        ])
    ]
})
export class NavigationComponent implements OnInit {

  teams: TeamOverviewModel[];
  menuState:string = 'in';
  hidden = true;
  Name: String="";
  OrgImage: string="";
  toolbarBackgroundColor: string = '#2196f3';
  toolbarForegroundColor: string = '#ffffff';
  //options$: Observable<Array<Option>> = this.themeService.getThemeOptions();

  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      share()
    );

  constructor( public _globals: Globals,
    private readonly themeService: ThemeService,
    private appColorsService: AppColorsService,
    private overlayContainer: OverlayContainer,
    private breakpointObserver: BreakpointObserver,
    private _router: Router,
    private teamService: TeamService,
    private destroyRef: DestroyRef) {}

  get isLoginRoute(): boolean {
    return this._router.url === '/login';
  }

  ngOnInit() {
    this.appColorsService.applyStoredThemeColors(this._globals.theme);
    this.applyToolbarColor();
   
   /*  this.breakpointObserver.observe(['(max-width: 800px)']).subscribe(res=>{
      if(res.matches && this._globals.isLoggedIn){
        this.sidenav.mode = 'over';
        this.sidenav.close();        
      }
      else{
        this.sidenav.mode = 'side';
        this.sidenav.open();        
      }
    }) */
    //console.log("ngOnint" + localStorage.getItem("isLoggedIn"));
    if(localStorage.getItem("isLoggedIn")==='true'){
      this.Name = localStorage.getItem("Name")??"";
      this.OrgImage = this.resolveOrgImagePath(localStorage.getItem('OrgLogo'));
      //console.log(this.OrgImage);
/*      this.teamService.getTeams().subscribe((data: any) =>{
      this.teams = data;
      if(this.teams.length>0){
        this._globals.TeamName =  this.teams[0].Name;
        //localStorage.setItem('SportId', this.teams[0].Spo);      
        this._globals.TeamImage = '/assets/img' + this.teams[0].SmallIconFileName;
      }
    }); */
    
    }
    
    this._globals.getMessage().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(msg=>{
      if(msg?.text === "Logged in"){
        const activeTheme = localStorage.getItem('theme') ?? this._globals.theme;
        this.appColorsService.applyStoredThemeColors(activeTheme);
      /*   this.teamService.getTeams().subscribe((data: any) =>{
          this.teams = data;
          if(this.teams.length>0){
            this._globals.TeamName =  this.teams[0].Name;
            //localStorage.setItem('SportId', this.teams[0].Spo);      
            this._globals.TeamImage = '/assets/img' + this.teams[0].SmallIconFileName;
          }
        }); */
        this.OrgImage = this.resolveOrgImagePath(localStorage.getItem('OrgLogo'));
        this.applyToolbarColor();
        //console.log(this.OrgImage);
        //console.log("login breakpointobserver");
        this.breakpointObserver.observe(['(max-width: 800px)']).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res=>{
          if(res.matches && this._globals.isLoggedIn){
            this.sidenav.mode = 'over';
            this.sidenav.close();
          }
          else{
            this.sidenav.mode = 'side';
            this.sidenav.open();
          }
        })
      }
    })

  }

  ngAfterViewInit(){
    
      this.breakpointObserver.observe(['(max-width: 800px)']).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res=>{
        if(res.matches && this._globals.isLoggedIn && this.sidenav){
          this.sidenav.mode = 'over';
          this.sidenav.close();        
        }
        else{
          if(this.sidenav){
            this.sidenav.mode = 'side';
            this.sidenav.open();        
          }
        }
      })
  }

  toggledrawer(){
    this.sidenav.toggle();
  }
  
  themeChangeHandler(themeToSet: string) {
    // console.log("themeToSet" + themeToSet);
    this.themeService.setTheme(themeToSet);
  }

  onNavClick(){
    //console.log(this.sidenav.mode);
    if(this.sidenav.mode==='over'){
      this.sidenav.close();
    }
  }

  isScoutingAdmin(): boolean {
    const rawRoles = localStorage.getItem('userRoles');
    if (!rawRoles) {
      return false;
    }

    try {
      const parsedRoles = JSON.parse(rawRoles) as string[];
      return Array.isArray(parsedRoles) && parsedRoles.includes('Scouting_Admin');
    } catch {
      return rawRoles.includes('Scouting_Admin');
    }
  }

  retract(){
      this.menuState = this.menuState === 'out' ? 'in' : 'out';
      this.hidden = !this.hidden;
  }

  logout(){
    
    localStorage.removeItem('userToken');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('Name');
    localStorage.removeItem('ToolbarColor');
    localStorage.removeItem('AppColors');
    localStorage.removeItem('isLoggedIn');
    this._globals.isLoggedIn=false;
    this.OrgImage = '';
    this.applyToolbarColor();
    this._router.navigateByUrl('/login');
  }

  private resolveOrgImagePath(orgLogoFileName: string | null): string {
    const fileName = orgLogoFileName?.trim();
    if (!fileName) {
      return '';
    }

    return `/assets/img/teams/${fileName}`;
  }

  get toolbarGradient(): string {
    const base = this.toolbarBackgroundColor;
    const dark = this.darkenColor(base, 50);
    return `linear-gradient(110deg, ${base} 0%, ${dark} 100%)`;
  }

  private applyToolbarColor() {
    const storedColor = localStorage.getItem('ToolbarColor');
    const color = this.normalizeColor(storedColor) ?? this.getThemeBackgroundColor();

    this.toolbarBackgroundColor = color;
    this.toolbarForegroundColor = this.getContrastColor(color);
    this._globals.toolbarBackgroundColor = color;
  }

  private darkenColor(color: string, amount: number): string {
    const rgb = this.toRgb(color);
    if (!rgb) return color;
    const clamp = (v: number) => Math.max(0, Math.min(255, v));
    return `rgb(${clamp(rgb.r - amount)}, ${clamp(rgb.g - amount)}, ${clamp(rgb.b - amount)})`;
  }

  private getThemeBackgroundColor(): string {
    const backgroundFromBody = getComputedStyle(document.body)
      .getPropertyValue('--mat-sys-background')
      .trim();

    if (backgroundFromBody) {
      return backgroundFromBody;
    }

    const background = getComputedStyle(document.documentElement)
      .getPropertyValue('--mat-sys-background')
      .trim();

    return background || '#f3f5f8';
  }

  private normalizeColor(color: string | null): string | null {
    if (!color) {
      return null;
    }

    const trimmedColor = color.trim();
    if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(trimmedColor)) {
      return trimmedColor;
    }

    if (/^rgb(a)?\(/i.test(trimmedColor) || /^hsl(a)?\(/i.test(trimmedColor)) {
      return trimmedColor;
    }

    return null;
  }

  private getContrastColor(backgroundColor: string): string {
    const rgb = this.toRgb(backgroundColor);
    if (!rgb) {
      return '#ffffff';
    }

    const brightness = ((rgb.r * 299) + (rgb.g * 587) + (rgb.b * 114)) / 1000;
    return brightness >= 160 ? '#111111' : '#ffffff';
  }

  private toRgb(color: string): { r: number; g: number; b: number } | null {
    if (color.startsWith('#')) {
      const hex = color.slice(1);
      const normalizedHex = hex.length === 3
        ? hex.split('').map(value => value + value).join('')
        : hex;

      const parsed = Number.parseInt(normalizedHex, 16);
      if (Number.isNaN(parsed)) {
        return null;
      }

      return {
        r: (parsed >> 16) & 255,
        g: (parsed >> 8) & 255,
        b: parsed & 255,
      };
    }

    const rgbMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (rgbMatch) {
      return {
        r: Number.parseInt(rgbMatch[1], 10),
        g: Number.parseInt(rgbMatch[2], 10),
        b: Number.parseInt(rgbMatch[3], 10),
      };
    }

    return null;
  }

  toggleTheme(){
    //console.log(this.language.substring(0,2));
    //console.log(value);
    var theme = localStorage.getItem("theme")??"dark";
    if(theme=='dark')
      theme = "light";
    else  
      theme = 'dark';
    localStorage.setItem("theme",theme);        
    this._globals.theme=theme;
    this.overlayContainer.getContainerElement().classList.remove("darkMode");
    this.overlayContainer.getContainerElement().classList.remove("lightMode");
    this.overlayContainer.getContainerElement().classList.add(theme + "Mode");
    this.appColorsService.applyStoredThemeColors(theme);
    
    
    // Update body tag with theme class
    document.body.classList.remove("dark-mode");
    document.body.classList.remove("light-mode");
    document.body.classList.add(theme + "-mode");
    this.applyToolbarColor();
  }
}